import axios from "axios";

const BASE_URL = "https://merck.neurabot.ai/";

const state = { caseList: [], isDoneFetching: false };

const actions = {
  getCase: ({ commit }, param) => {
    commit("resetCase");
    axios({
      method: "get",
      url: BASE_URL + `api/list-cases/` + param.diseaseId + "/",
      params: {
        assigment_id: param.assignmentId,
      },
    })
      .then((resp) => commit("setCase", resp.data))
      .catch((err) => {
        console.log(err);
      });
  },
};

const mutations = {
  resetCase: (state) => {
    state.caseList = [];
    state.isDoneFetching = false;
  },
  setCase: (state, resp) => {
    state.caseList = resp.cases;
    state.isDoneFetching = true;
  },
};

export default {
  state,
  actions,
  mutations,
};
